import * as React from 'react';

import { ApButtonIcon } from '@alixpartners/ui-components';
import {
	Wrapper,
	Title,
	TitleWrapper,
	ActionsWrapper,
	Divider,
} from './ListItem.styles';
import { SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(({ disabled }) => (
	<ApButtonIcon iconName="baseline_drag_handle" disabled={disabled} />
));

export const ListItem = ({ data, onHideClick, order }) => {
	const { name, hidden } = data;

	const handleHideClick = e => {
		e.preventDefault();
		onHideClick(order);
	};

	return (
		<Wrapper shaded={hidden}>
			<TitleWrapper>
				<Title>{name}</Title>
			</TitleWrapper>
			<ActionsWrapper>
				<ApButtonIcon
					iconName={!hidden ? 'outline_visability' : 'outline_visability_off'}
					onClick={handleHideClick}
				/>
				<Divider />
				<DragHandle disabled={hidden} />
			</ActionsWrapper>
		</Wrapper>
	);
};
